<div
  class="flex flex-col gap-[1.5rem] p-[2.5rem] max-h-[15.625rem] overflow-y-auto filters-scrollbar"
>
  <div class="flex items-center justify-between">
    <h4>{{title()}}</h4>
    @if(filterExists()) {
    <span class="mt-1 truncate"
      >{{countSelectedFilters()}} {{ countSelectedFilters() > 1 ?
      ('components.filterResultSection.manyFiltersSelectedText' | transloco) :
      ('components.filterResultSection.oneFilterSelectedText' | transloco)
      }}</span
    >
    }
  </div>
  @if(filterExists()) {
  <div class="flex flex-wrap gap-2">
    @for( filter of filter().filters; track $index ) {
    <span class="px-3 bg-vinciBlue-600 text-white rounded-3xl font-normal"
      >{{ filter.translation }}</span
    >} @if (extraSelectedFilterTranslations()?.length > 0) { @for(
    extraTranslation of extraSelectedFilterTranslations(); track $index ) { @if
    (extraTranslation && extraTranslation.trim().length > 0) {
    <span class="px-3 bg-vinciBlue-600 text-white rounded-3xl font-normal"
      >{{ extraTranslation }}</span
    >
    } } }
  </div>
  } @else {
  <p class="self-center">{{textIfNoFilter()}}</p>
  }
</div>
